// Import the functions needed from the Firebase SDKs
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';

// Configuration for the first Firebase project (Project A)
const firebaseConfig = {
  apiKey: "AIzaSyCpLJ05ZQSBg40kKMbgLMmIZMrP4EBFPBY",
  authDomain: "content-filter-154e4.firebaseapp.com",
  projectId: "content-filter-154e4",
  storageBucket: "content-filter-154e4.appspot.com",
  messagingSenderId: "625231610442",
  appId: "1:625231610442:web:916bd684a9eb964c179cb3"
};

// Configuration for the second Firebase project (Project B)
const firebaseConfigB = {
  apiKey: "AIzaSyC9vMv6tF_NHLLG3dC3tyr59YPrj0cunu0",
  authDomain: "drip-feed-a1ee0.firebaseapp.com",
  projectId: "drip-feed-a1ee0",
  storageBucket: "drip-feed-a1ee0.firebasestorage.app",
  messagingSenderId: "749801689812",
  appId: "1:749801689812:web:ecd409a2001440d8c4e141"
};

// Initialize Firebase app (Project A)
const app = initializeApp(firebaseConfig);

// Initialize a secondary Firebase app (Project B)
const appB = initializeApp(firebaseConfigB, "secondaryApp");

// Initialize Firebase services for Project A
const auth = getAuth(app);
const firestore = getFirestore(app);
const functions = getFunctions(app);

// Initialize Firebase services for Project B
const authB = getAuth(appB);
const firestoreB = getFirestore(appB);
const functionsB = getFunctions(appB);

const db = getFirestore(appB); 

// Export Firebase services for use in other parts of the app
export { auth, firestore, functions, authB, firestoreB, functionsB, db };

